import type {
  SelfOrderCreateRequest,
  SelfOrderCreateResult,
  SelfOrderLoyaltyIdentity,
  SelfOrderMenu,
  SelfOrderPayResult,
  SelfOrderSession,
  SelfOrderStatus,
} from "@ramoo/contracts"

/* Semua panggilan relatif ke origin sendiri (`order.ramoo.id`) — Worker `ramoo-order` yang mem-proxy
   ke API. Scope (outlet + meja) dari token di URL, tak pernah dari body. */
const dasar = (outletId: string, token: string) =>
  `/v1/self-order/${encodeURIComponent(outletId)}/${encodeURIComponent(token)}`

async function ambil<T>(url: string, init?: RequestInit): Promise<T> {
  const r = await fetch(url, init)
  if (!r.ok) {
    const e = (await r.json().catch(() => null)) as { error?: { message?: string } } | null
    throw new Error(e?.error?.message ?? `Gagal memuat (${r.status})`)
  }
  return r.json() as Promise<T>
}

export const ambilSesi = (outletId: string, token: string) =>
  ambil<SelfOrderSession>(dasar(outletId, token))

export const ambilMenu = (outletId: string, token: string) =>
  ambil<SelfOrderMenu>(`${dasar(outletId, token)}/menu`)

export const kirimPesanan = (outletId: string, token: string, body: SelfOrderCreateRequest) =>
  ambil<SelfOrderCreateResult>(`${dasar(outletId, token)}/order`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  })

export const kirimOtpLoyalty = (outletId: string, token: string, phone: string) =>
  ambil<{ ok: true; expiresInSeconds: number }>(`${dasar(outletId, token)}/loyalty/otp`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ phone }),
  })

export const verifikasiOtpLoyalty = (
  outletId: string,
  token: string,
  phone: string,
  code: string,
) =>
  ambil<SelfOrderLoyaltyIdentity>(`${dasar(outletId, token)}/loyalty/otp/verify`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ phone, code }),
  })

/** Minta QRIS untuk membayar pesanan. Nominal dihitung server; idempoten per pesanan. */
export const bayarQris = (outletId: string, token: string, orderId: string) =>
  ambil<SelfOrderPayResult>(`${dasar(outletId, token)}/order/${encodeURIComponent(orderId)}/pay`, {
    method: "POST",
  })

/** Status pesanan (polling sampai "paid"); server ikut reconcile ke Doku di sini. */
export const statusPesanan = (outletId: string, token: string, orderId: string) =>
  ambil<SelfOrderStatus>(`${dasar(outletId, token)}/order/${encodeURIComponent(orderId)}`)
